import { API } from '..'
import { identityServiceUrl } from '../../utils/constants'

export const postCustomerDetails = (data: unknown) => {
  return API.post(`${identityServiceUrl}/internal/partners`, data)
}

export const patchCustomerDetails = (partnerId: string, data: unknown) =>
  API.patch(`${identityServiceUrl}/partners/${partnerId}`, data)
